module.exports = __webpack_public_path__ + "static/media/download.419e4bc0.svg";